module.exports = "/icon-MapBuilder.jpg?88650e";